<template>
  <div class="c-dry">
    <ul class="c-dry-list">
      <li class="c-dry-item">
        <div class="c-dry-item-title">
          <span class="c-dry-item-index">{{`(${course}分)`}} {{index + 1}}.</span>
          <p class="c-dry-item-slot" v-html="`${content}`">
          </p>
          <slot></slot>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: null
    },
    index: {
      type: Number,
      default: null
    },
    course: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss">
.c-dry{
  max-width: 1200px;
  margin: 0 auto;
  .c-dry-item{
    margin-bottom: 50px;
  }
  .c-dry-item-title{
    line-height: 21px;
    font-size: 16px;
    margin-bottom: 30px;
    position: relative;
    .c-dry-item-index{
      font-weight:700;
      position: absolute;
      left: 0;
      top: 0;
      line-height: 30px;
    }
    .c-dry-item-slot{
      margin-bottom: 30px;
      line-height: 30px;
      text-indent: 72px;
      word-break: break-all;
      strong{
        font-weight: 700;
      }
      img{
        max-width: 100%;
        height: auto;
        vertical-align: top;
      }
    }
  }
}
</style>
